// extracted by mini-css-extract-plugin
export var standaloneTable = "_1m-0";
export var standaloneTableWithBodyFill = "_1m-1";
export var withExtraHeader = "_1m-2";